import { render, staticRenderFns } from "./OrderGroupingList.vue?vue&type=template&id=077b37d9&scoped=true&"
import script from "./OrderGroupingList.vue?vue&type=script&lang=js&"
export * from "./OrderGroupingList.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupingList.vue?vue&type=style&index=0&id=077b37d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077b37d9",
  null
  
)

export default component.exports